import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';
import ImageUploadField from '../components/ImageUploadField';

function PromotionsPage() {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ eventId: '', titulo: '', descripcion: '', url: '', imagen: '', orden: 0 });

  const load = async () => {
    try {
      const [p, e] = await Promise.all([api.get(endpoints.promotions(), token), api.get(endpoints.events(), token)]);
      setData(p);
      setEvents(e);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(endpoints.promotion(editing.id), form, token);
      else await api.post(endpoints.promotions(), form, token);
      setModalOpen(false);
      setEditing(null);
      setForm({ eventId: '', titulo: '', descripcion: '', url: '', imagen: '', orden: 0 });
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm('¿Eliminar promoción?')) return;
    try {
      await api.delete(endpoints.promotion(row.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'titulo', label: 'Título' },
    { key: 'url', label: 'URL', render: (val) => val ? <a href={val} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline truncate block max-w-[120px]">Ver</a> : '—' },
    { key: 'eventId', label: 'Evento' },
  ];

  const emptyForm = { eventId: events[0]?.id || '', titulo: '', descripcion: '', url: '', imagen: '', orden: 0 };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Promociones</h1>
        <button onClick={() => { setEditing(null); setForm(emptyForm); setModalOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nueva promoción</button>
      </div>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={data} onEdit={(r) => { setEditing(r); setForm(r); setModalOpen(true); }} onDelete={handleDelete} />}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar promoción' : 'Nueva promoción'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div><label className="block text-sm font-medium mb-1">Evento</label><select value={form.eventId} onChange={(e) => setForm((f) => ({ ...f, eventId: e.target.value }))} className="w-full px-3 py-2 border rounded">{events.map((ev) => <option key={ev.id} value={ev.id}>{ev.nombre}</option>)}</select></div>
          <div><label className="block text-sm font-medium mb-1">Título</label><input value={form.titulo || ''} onChange={(e) => setForm((f) => ({ ...f, titulo: e.target.value }))} className="w-full px-3 py-2 border rounded" required /></div>
          <div><label className="block text-sm font-medium mb-1">Descripción</label><textarea value={form.descripcion || ''} onChange={(e) => setForm((f) => ({ ...f, descripcion: e.target.value }))} className="w-full px-3 py-2 border rounded" rows={3} /></div>
          <div><label className="block text-sm font-medium mb-1">URL (enlace de redirección)</label><input type="url" value={form.url || ''} onChange={(e) => setForm((f) => ({ ...f, url: e.target.value }))} placeholder="https://..." className="w-full px-3 py-2 border rounded" /></div>
          <ImageUploadField label="Imagen (URL)" value={form.imagen || ''} onChange={(v) => setForm((f) => ({ ...f, imagen: v }))} token={token} />
          <div><label className="block text-sm font-medium mb-1">Orden</label><input type="number" value={form.orden ?? 0} onChange={(e) => setForm((f) => ({ ...f, orden: parseInt(e.target.value, 10) || 0 }))} className="w-full px-3 py-2 border rounded" /></div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Guardar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default PromotionsPage;
